import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './LegalPage.css';

function NotFoundPage({ user, signIn, credits, creditsLoading }) {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <Header user={user} signIn={signIn} credits={credits} creditsLoading={creditsLoading} />
      <main className="legal-content" style={{ textAlign: 'center', paddingTop: '80px' }}>
        <h1 style={{ fontSize: '4rem', marginBottom: '8px' }}>404</h1>
        <p style={{ fontSize: '1.2rem', color: '#aaa', marginBottom: '32px' }}>
          This page doesn't exist.
        </p>
        <button
          onClick={() => navigate('/')}
          className="btn-teal"
          style={{ padding: '12px 32px', fontSize: '1rem' }}
        >
          Go Home
        </button>
      </main>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
